/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AddEditUserBodyBody,
    EditMeBodyBody,
    ForceSetUserPasswordBodyBody,
    ForceSetUserPasswordSuccessResponseResponse,
    GetUsersParams,
    RequestStatusResponseResponse,
    UserCreateSuccessResponseResponse,
    UserSuccessResponseResponse,
    UsersSuccessResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Get users of the venue matching the filters
 */
export const getUsers = (id: number, params?: GetUsersParams, signal?: AbortSignal) => {
    return customInstance<UsersSuccessResponseResponse>({
        url: `/users/${id}/byvenues`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetUsersQueryKey = (id?: number, params?: GetUsersParams) => {
    return [`/users/${id}/byvenues`, ...(params ? [params] : [])] as const;
};

export const getGetUsersQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsers>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    params?: GetUsersParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUsersQueryKey(id, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({ signal }) =>
        getUsers(id, params, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsers>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>;
export type GetUsersQueryError = APIErrorResponseResponse;

/**
 * @summary Get users of the venue matching the filters
 */

export function useGetUsers<
    TData = Awaited<ReturnType<typeof getUsers>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    params?: GetUsersParams,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetUsersQueryOptions(id, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Add new user to the venue
 */
export const addUser = (
    id: number,
    addEditUserBodyBody: AddEditUserBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<UserCreateSuccessResponseResponse>({
        url: `/users/${id}/byvenues`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addEditUserBodyBody,
        signal,
    });
};

export const getAddUserMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addUser>>,
        TError,
        { id: number; data: AddEditUserBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addUser>>,
    TError,
    { id: number; data: AddEditUserBodyBody },
    TContext
> => {
    const mutationKey = ['addUser'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addUser>>,
        { id: number; data: AddEditUserBodyBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return addUser(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddUserMutationResult = NonNullable<Awaited<ReturnType<typeof addUser>>>;
export type AddUserMutationBody = AddEditUserBodyBody;
export type AddUserMutationError = APIErrorResponseResponse;

/**
 * @summary Add new user to the venue
 */
export const useAddUser = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addUser>>,
        TError,
        { id: number; data: AddEditUserBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addUser>>,
    TError,
    { id: number; data: AddEditUserBodyBody },
    TContext
> => {
    const mutationOptions = getAddUserMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get user by id and venue id
 */
export const getUser = (id: number, venueId: number, signal?: AbortSignal) => {
    return customInstance<UserSuccessResponseResponse>({
        url: `/users/${id}/${venueId}`,
        method: 'GET',
        signal,
    });
};

export const getGetUserQueryKey = (id?: number, venueId?: number) => {
    return [`/users/${id}/${venueId}`] as const;
};

export const getGetUserQueryOptions = <
    TData = Awaited<ReturnType<typeof getUser>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    venueId: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserQueryKey(id, venueId);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) =>
        getUser(id, venueId, signal);

    return { queryKey, queryFn, enabled: !!(id && venueId), ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getUser>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>;
export type GetUserQueryError = APIErrorResponseResponse;

/**
 * @summary Get user by id and venue id
 */

export function useGetUser<
    TData = Awaited<ReturnType<typeof getUser>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    venueId: number,
    options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetUserQueryOptions(id, venueId, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Edit user
 */
export const editUser = (id: number, venueId: number, addEditUserBodyBody: AddEditUserBodyBody) => {
    return customInstance<UserSuccessResponseResponse>({
        url: `/users/${id}/${venueId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: addEditUserBodyBody,
    });
};

export const getEditUserMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editUser>>,
        TError,
        { id: number; venueId: number; data: AddEditUserBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editUser>>,
    TError,
    { id: number; venueId: number; data: AddEditUserBodyBody },
    TContext
> => {
    const mutationKey = ['editUser'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editUser>>,
        { id: number; venueId: number; data: AddEditUserBodyBody }
    > = (props) => {
        const { id, venueId, data } = props ?? {};

        return editUser(id, venueId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditUserMutationResult = NonNullable<Awaited<ReturnType<typeof editUser>>>;
export type EditUserMutationBody = AddEditUserBodyBody;
export type EditUserMutationError = APIErrorResponseResponse;

/**
 * @summary Edit user
 */
export const useEditUser = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editUser>>,
        TError,
        { id: number; venueId: number; data: AddEditUserBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editUser>>,
    TError,
    { id: number; venueId: number; data: AddEditUserBodyBody },
    TContext
> => {
    const mutationOptions = getEditUserMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete user by id
 */
export const deleteUserFromVenue = (id: number, venueId: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/users/${id}/${venueId}`,
        method: 'DELETE',
    });
};

export const getDeleteUserFromVenueMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteUserFromVenue>>,
        TError,
        { id: number; venueId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserFromVenue>>,
    TError,
    { id: number; venueId: number },
    TContext
> => {
    const mutationKey = ['deleteUserFromVenue'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteUserFromVenue>>,
        { id: number; venueId: number }
    > = (props) => {
        const { id, venueId } = props ?? {};

        return deleteUserFromVenue(id, venueId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteUserFromVenueMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteUserFromVenue>>
>;

export type DeleteUserFromVenueMutationError = APIErrorResponseResponse;

/**
 * @summary Delete user by id
 */
export const useDeleteUserFromVenue = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteUserFromVenue>>,
        TError,
        { id: number; venueId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteUserFromVenue>>,
    TError,
    { id: number; venueId: number },
    TContext
> => {
    const mutationOptions = getDeleteUserFromVenueMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Force set a user's password (requires users.manage over a manageable target)
 */
export const forceSetUserPassword = (
    id: number,
    venueId: number,
    forceSetUserPasswordBodyBody?: ForceSetUserPasswordBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<ForceSetUserPasswordSuccessResponseResponse>({
        url: `/users/${id}/${venueId}/force-password`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: forceSetUserPasswordBodyBody,
        signal,
    });
};

export const getForceSetUserPasswordMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof forceSetUserPassword>>,
        TError,
        { id: number; venueId: number; data: ForceSetUserPasswordBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof forceSetUserPassword>>,
    TError,
    { id: number; venueId: number; data: ForceSetUserPasswordBodyBody },
    TContext
> => {
    const mutationKey = ['forceSetUserPassword'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof forceSetUserPassword>>,
        { id: number; venueId: number; data: ForceSetUserPasswordBodyBody }
    > = (props) => {
        const { id, venueId, data } = props ?? {};

        return forceSetUserPassword(id, venueId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ForceSetUserPasswordMutationResult = NonNullable<
    Awaited<ReturnType<typeof forceSetUserPassword>>
>;
export type ForceSetUserPasswordMutationBody = ForceSetUserPasswordBodyBody;
export type ForceSetUserPasswordMutationError = APIErrorResponseResponse;

/**
 * @summary Force set a user's password (requires users.manage over a manageable target)
 */
export const useForceSetUserPassword = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof forceSetUserPassword>>,
        TError,
        { id: number; venueId: number; data: ForceSetUserPasswordBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof forceSetUserPassword>>,
    TError,
    { id: number; venueId: number; data: ForceSetUserPasswordBodyBody },
    TContext
> => {
    const mutationOptions = getForceSetUserPasswordMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Edit own user
 */
export const editMe = (editMeBodyBody: EditMeBodyBody) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/users/me`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: editMeBodyBody,
    });
};

export const getEditMeMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editMe>>,
        TError,
        { data: EditMeBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editMe>>,
    TError,
    { data: EditMeBodyBody },
    TContext
> => {
    const mutationKey = ['editMe'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editMe>>,
        { data: EditMeBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return editMe(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditMeMutationResult = NonNullable<Awaited<ReturnType<typeof editMe>>>;
export type EditMeMutationBody = EditMeBodyBody;
export type EditMeMutationError = APIErrorResponseResponse;

/**
 * @summary Edit own user
 */
export const useEditMe = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editMe>>,
        TError,
        { data: EditMeBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editMe>>,
    TError,
    { data: EditMeBodyBody },
    TContext
> => {
    const mutationOptions = getEditMeMutationOptions(options);

    return useMutation(mutationOptions);
};
